<template>
  <v-col v-if="isTracked" cols="6" md="6" lg="3" class="d-flex flex-column">
    <v-card class="flex d-flex flex-column" :class="{ 'green': isGoalCompleted }">
      <v-card-title>
        <p class="headline">{{ title }}</p>
      </v-card-title>
      <v-card-text>
        <p class="display-3">{{ value }}/{{ goal }}</p>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "PomodoroReviewCard",

  props: {
    title: String,
    value: Number,
    goal: Number,
    isTracked: Boolean,
  },
  computed: {
    isGoalCompleted() {
      return this.value >= this.goal;
    }
  }
}
</script>

<style lang="scss" scoped>
.headline {
  word-break: break-word;
}
</style>
